import base from '../AccidentsPage/route';

export default (id = ':id') => `${base()}/${id}`;
